import React from 'react';

import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import {
  Link,
  styled,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';



const ClickableBox = styled(Link)(({ theme }) => ({
  display: 'flex',
  cursor: 'pointer',
  marginBottom: theme.spacing(3)
}));



const ButtonTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 14,
  letterSpacing: 0.25,
  marginLeft: theme.spacing(1)
}));



export interface IProps {
  label: string;
}

export const FC: React.FC<IProps> = props => {
  const navigate = useNavigate();

  return (
    <ClickableBox onClick={() => navigate(-1)}>
      <ArrowBackIcon color='primary' />

      <ButtonTypography>
        {props.label}
      </ButtonTypography>
    </ClickableBox>
  );
};
